<template>
    <DefaultLayout>
        <div class="container-fluid main-content">
            <div id="progress-bar" class="step-progress-bar">
                <progress-bar 
                    v-model="currentStep.name" 
                    v-bind:type="visitorInformation.visitorType" 
                    v-bind:steps="steps"
                />                
            </div>
            <div class="row questions">
                <div class="col">
                    <client-type-question v-if="currentStep.name == 'clientType'"
                        @update-client-type="updateClientType"
                        @go-to-next-step="goToNextStep"/>

                    <Address v-if="currentStep.name == 'address'" 
                        v-model="visitorInformation.address"
                        v-on:location="getLocation"
                        v-on:formLocation="getFormLocation" 
                        v-bind:source="visitorInformation.source" 
                        v-bind:type="visitorInformation.visitorType"
                        v-bind:urlAddress="location"/>

                    <property-type v-if="currentStep.name == 'propertyType'"
                        v-model="visitorInformation.propertyType"/>

                    <estimate-value v-if="currentStep.name == 'price'" 
                        v-model="visitorInformation.price" 
                        v-bind:type="visitorInformation.visitorType"/>

                    <estimate-time-frame v-if="currentStep.name == 'timeFrame'"
                        v-model="visitorInformation.timeFrame"/>

                    <buy-question v-if="currentStep.name == 'buyQuestion'" 
                        @update-buyer-loc="updateBuyerLocation"
                        @update-buyer-ques="updateBuyerQuestion"
                        @go-to-next-step="goToNextStep"/>

                    <visitor-info v-if="currentStep.name == 'visitorInfo'"
                        v-model="visitorInformation.contactInfo"
                        v-bind:source="visitorInformation.source"/>

                    <your-agent v-if="currentStep.name == 'agentIntroduction'"
                        v-bind:source="visitorInformation.source" 
                        v-bind:type="visitorInformation.visitorType"
                        v-bind:save-response="saveResponse"
                    />
                </div>
            </div>
            <div class="row back-next nav-controls">
                <div class="col">
                    <b-button pill variant="outline-primary" @click="goBack()" v-show="showBackButton"
                                size="lg"><span
                            class="back-button-text">Back</span>
                    </b-button>
                </div>
                <div class="col">
                    <b-button                            
                        v-show="showNextButton"
                        ref="nextBtn"
                        pill
                        variant="outline-primary"
                        class="button-text"
                        size="lg"
                        :disabled="disableNextButton"
                        @click="goNext()"
                    >
                        <span class="next-button-text" v-on:keydown="enterKey">
                            {{nextButtonLabel}}
                        </span>
                    </b-button>

                </div>
            </div>
            <div>
                <input id="lead_id" name="lead_id" type="hidden" v-model="leadId"/>
            </div>
        </div>
        <!-- <template v-slot:footerNav>
            <div class="nav-footer">
                <div>
                    <agent-companies v-if="currentStep.name === 'address'"/>
        
                    <TrustPilotReview v-if="isReviewStep" :step="currentStep.name"/>
        
                    <span>Need help? Call <a href="tel:18007504014"> 1-800-750-4014</a></span>
                </div>
                <div>
                    <img class="logo" src="https://static.idealagent.com/web/ia/idealagent-logo.png" alt="Ideal Agent Logo" >
                </div>
            </div>
        </template> -->
        <template v-slot:footer>
            <ContentFooter />
        </template>
    </DefaultLayout>
</template>

<script>
import DefaultLayout from "@/layout/DefaultLayout.vue";
import Address from "@/components/Address";
import VisitorInfo from "@/components/VisitorInfo";
import YourAgent from "@/components/YourAgent";
import ProgressBar from "@/components/ProgressBar";
import PropertyType from "@/components/PropertyType";
import EstimateValue from "@/components/EstimateValue";
import EstimateTimeFrame from "@/components/EstimateTimeFrame";
import BuyQuestion from "@/components/BuyQuestion";
import ContentFooter from "@/components/ContentFooter";
import ClientTypeQuestion from "@/components/ClientTypeQuestion";
import { getMapBoxSelections, getLastLocationPreference, 
    getUrlValue, getUrlValues, hasAllFieldNames, getMapBoxMatch, getMissingUrlValuesFromObject } from "@/utils";
import { saveField, saveSeller, getVisitorId  }  from "@/services/apiService";

    export default {
        name: 'App',
        data() {
            const urlAddressParts = { 
                ...getUrlValues(['address', 'street', 'city', 'state', 'zip']),
                longitude: getUrlValue('lng'),
                latitude: getUrlValue('lat')
            };
            const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            return {
                visitorInformation: {
                    address: null,
                    propertyType: null,
                    timeFrame: null,
                    timeZone,
                    contactInfo: {
                        firstName: getUrlValue('firstName'),
                        lastName: getUrlValue('lastName'),
                        phone: getUrlValue('phone'),
                        phoneIsValid: null,
                        email: getUrlValue('email')
                    },
                    price: -1,
                    buyer: {
                        buyLocation: null,
                        buyQuestion: null,
                        city: getUrlValue('buyCity'),
                        state: getUrlValue('buyState'),
                        latitude: null,
                        longitude: null
                    },
                    source: null,
                    url: null,
                    visitorType: null,
                    visitorId: getVisitorId()
                },
                currentStep: null,
                nextButtonLabel: 'Next',
                location: urlAddressParts,
                onlySellers: true,
                leadId: null,
                mustValidatePhone: true,
                urlParams: undefined,
                hasGoneBack: false,
                missingType: true,
                saveResponse: {}
            }
        },
        components: {
            DefaultLayout,
            EstimateTimeFrame,
            EstimateValue,
            VisitorInfo,
            PropertyType,
            Address,
            YourAgent,
            ProgressBar,
            BuyQuestion,
            ContentFooter,
            ClientTypeQuestion
        },
        methods: {

            getLocation: function (newLocation) {
                if (newLocation.type === 'buy') {
                    this.visitorInformation.buyer.city = newLocation.city
                    this.visitorInformation.buyer.state = newLocation.state
                    this.visitorInformation.buyer.latitude = newLocation.latitude
                    this.visitorInformation.buyer.longitude = newLocation.longitude
                } else {
                    this.location = newLocation;
                }
                this.location = newLocation;
                this.latLonAdvanceNextStep();
            },

            getFormLocation: function (newLocation) {       
                this.location = newLocation;
            },

            latLonAdvanceNextStep: function () {
                if (!this.hasGoneBack) {
                    this.goNext(); 
                }                               
            },

            getType: function (type) {
                return type === 'buy' ? 'BUYER' : 'SELLER'
            },

            enterKey: function (event) {
                let key = event.key || event.keyCode;
                if (key === 'Enter' && !this.disableNextButton) {
                    this.goNext();
                }
            },

            /**
             * Persists current state of the seller (which should be fully populated) and initiates the sales process
             * */
            saveVisitorInformation: async function () {
                if (this.mustValidatePhone && this.visitorInformation.contactInfo.phoneIsValid) {

                    const type = this.getType(this.visitorInformation.visitorType)

                    let payload = {
                        visitorId: this.visitorInformation.visitorId,
                        firstName: this.visitorInformation.contactInfo.firstName,
                        lastName: this.visitorInformation.contactInfo.lastName,
                        phone: this.visitorInformation.contactInfo.phone,
                        email: this.visitorInformation.contactInfo.email,
                        timeZone: this.visitorInformation.timeZone,
                        url: this.visitorInformation.url,
                        leadSource: this.visitorInformation.source
                    }

                    if (this.visitorInformation?.buyer?.city) {
                        payload['buying'] = {
                            city: this.visitorInformation.buyer.city,
                            state: this.visitorInformation.buyer.state,
                            latitude: this.visitorInformation.buyer.latitude,
                            longitude: this.visitorInformation.buyer.longitude,
                        };
                    }

                    if (type === 'SELLER') {
                        payload['selling'] = {
                            street: this.location.street,
                            street2: null,
                            city: this.location.city,
                            state: this.location.state,
                            zip: this.location.zip,
                            county: this.location.county,
                            latitude: this.location.latitude,
                            longitude: this.location.longitude,
                            estimatedValue: null,
                            propertyType: null,
                        };
                    }
                    
                    if (this.visitorInformation.visitorType === 'cash') {
                        payload.Seller_Buyer_or_Both = 'YES'
                        payload.Cash_Offer_Status = 'Requested'
                    }

                    const res = await saveSeller(payload);

                    if (!this.isEmpty(res)) {
                        this.saveResponse = res;
                        this.leadId = res.id;
                    } else {
                        this.saveResponse = {
                            id: 0,
                            success: false
                        }
                    }
                    

                } else {
                    console.log('must validate phone message to be displayed');
                }
                
            },
            /**
             * Use this function to move to the next screen
             **/
            goNext: function () {
                this.currentStep = this.steps[this.getNextStepNumber];
                if (this.currentStep.name === 'visitorInfo') {
                    this.nextButtonLabel = 'Finish';
                } else {
                    this.nextButtonLabel = 'Next';
                }
                if (this.currentStep.name == 'agentIntroduction') {
                    this.saveVisitorInformation();
                }
            },
            /**
             * Use this function to move to the previous screen
             **/
            goBack: function () {
                this.hasGoneBack = true;
                this.currentStep = this.steps[this.getPreviousStepNumber];
                if (this.currentStep.name === 'visitorInfo') {
                    this.nextButtonLabel = 'Finish';
                } else {
                    this.nextButtonLabel = 'Next';
                }
            },
            /**
             * Watches for single click selections and moves the user to the next screen without needing to click next
             */
            autoProceed: function (newValue) {
                if (this.currentStep.name === 'clientType' && !this.missingType) {
                    this.goNext();
                }
                if (this.currentStep.name === 'propertyType' && !this.isEmpty(newValue.propertyType)) {
                    this.goNext();
                }
                if (this.currentStep.name === 'timeFrame' && !this.isEmpty(newValue.timeFrame)) {
                    this.goNext();
                }
                if (this.currentStep.name === 'buyQuestion'
                    && !this.isEmpty(newValue.buyQuestion)
                    && newValue.buyQuestion === 'NO') {
                    this.goNext();
                } 
            },
            getLocationInformation: function () {  
                const lastLocation = getLastLocationPreference();
                return getMapBoxSelections(lastLocation);
            },
            updateBuyerLocation: function (value) {
                if (value.place) this.visitorInformation.buyer.buyLocation = value.place;
                if (value.city) this.visitorInformation.buyer.city = value.city;
                if (value.state) this.visitorInformation.buyer.state = value.state;
                if (value.latitude) this.visitorInformation.buyer.latitude = value.latitude;
                if (value.longitude) this.visitorInformation.buyer.longitude = value.longitude;
            },
            updateBuyerQuestion: function (value) {
                this.visitorInformation.buyer.buyQuestion = value;
            },
            updateClientType: function (value) {
                this.visitorInformation.visitorType = value;
            },
            goToNextStep: function () {
                this.goNext()
            },
        },
        computed: {
            steps: function () {
                return this.visitorInformation.visitorType == 'buy' ? [
                    { order: 0, name: 'clientType' },
                    { order: 1, name: 'address' },
                    { order: 2, name: 'visitorInfo' },
                    { order: 3, name: 'agentIntroduction' }
                ] : [
                    {order: 0, name: 'address'},
                    {order: 1, name: 'buyQuestion'},
                    {order: 2, name: 'visitorInfo'},
                    {order: 3, name: 'agentIntroduction'}
                ]
            },
            isReviewStep: function () {
                return this.currentStep.name === 'clientType' ||
                    this.currentStep.name === 'propertyType' || 
                    this.currentStep.name === 'price' ||
                    this.currentStep.name === 'timeFrame' ||
                    this.currentStep.name === 'buyQuestion' ||
                    this.currentStep.name === 'visitorInfo' ||
                    this.currentStep.name === 'agentIntroduction';
            },
            getNextStepNumber: function () {
                return this.currentStep.order + 1;
            },
            getPreviousStepNumber: function () {
                return this.currentStep.order - 1;
            },
            /**
             * Determines if the BACK button should be displayed
             * @returns {boolean|boolean}
             */
            showBackButton: function () {
                return this.currentStep.order > 0 && this.currentStep.order != this.steps.length - 1
            },
            /**
             * Determines if the NEXT button should be displayed
             * @returns {boolean}
             */
            showNextButton: function () {
                return this.currentStep.order < this.steps.length - 1;
            },
            /**
             * Determines if the NEXT button should be enabled based on current step and information filled in
             * @returns {boolean}
             */
            disableNextButton: function () {
                const stepName = this.currentStep.name;
                switch (stepName) {
                    case 'address':
                        return this.isEmpty(this.visitorInformation.address);
                    case 'propertyType':
                        return this.isEmpty(this.visitorInformation.propertyType);
                    case 'price':
                        return this.isEmpty(this.visitorInformation.price);
                    case 'timeFrame':
                        return this.isEmpty(this.visitorInformation.timeFrame);
                    case 'buyQuestion':
                        return (this.isEmpty(this.visitorInformation?.buyer?.buyQuestion) ||  
                        this.visitorInformation?.buyer?.buyQuestion === 'YES' && 
                        this.isEmpty(this.visitorInformation?.buyer?.buyLocation));
                    case 'visitorInfo':
                        if (this.mustValidatePhone) {
                            return this.isEmpty(this.visitorInformation.contactInfo.firstName) ||
                                this.isEmpty(this.visitorInformation.contactInfo.lastName) ||
                                this.isEmpty(this.visitorInformation.contactInfo.phone) ||
                                this.isEmpty(this.visitorInformation.contactInfo.email) ||
                                this.isEmpty(this.visitorInformation.contactInfo.phoneIsValid);
                        }
                        return this.isEmpty(this.visitorInformation.contactInfo.firstName) ||
                             this.isEmpty(this.visitorInformation.contactInfo.lastName) ||
                            (this.isEmpty(this.visitorInformation.contactInfo.phone) ||
                                (this.visitorInformation.contactInfo.phone.length !== 10));

                    default:
                        return true;
                }             
            }
        },
        watch: {

            visitorInformation:
                {
                    handler: function (newValue) {
                        this.autoProceed(newValue);
                    },
                    deep: true
                }
        },
        created: async function () {
            let app = this;
            this.currentStep = this.steps[0];

            this.urlParams = new URLSearchParams(window.location.search);

            this.visitorInformation.url = window.location.href;
            const urlType = this.onlySellers ? 'sell' : getUrlValue('type');
            if (urlType) this.missingType = false;
            this.visitorInformation.visitorType = urlType ?? 'sell';
           
            // get any query string info and store
            const source = getUrlValue('source');
            const address = getUrlValue('address');
            const lat = getUrlValue('lat');
            const lng = getUrlValue('lng');
            const mapBoxPartsRequired = ['city','state','zip','street'];

            this.visitorInformation.source = source ?? 'Direct';

            if (address) {
                this.visitorInformation.address = address;
                saveField('Address', address);
            }

            if (lat && lng && this.visitorInformation.visitorType !== 'buy') {
                const hasAllLocationParts = hasAllFieldNames(this.location, mapBoxPartsRequired);
                if (!hasAllLocationParts) {
                    const match = await getMapBoxMatch(address, lat, lng, 'address');
                    if (match?.place_name) {
                        const parts = getMapBoxSelections(match);
                        const missing = getMissingUrlValuesFromObject(parts, mapBoxPartsRequired);
                        this.location = { ...this.location, ...missing }
                        this.latLonAdvanceNextStep();
                    }
                } else {
                    this.latLonAdvanceNextStep();
                }
            } else if (lat && lng && this.visitorInformation.visitorType === 'buy') {
                delete this.location['street'];
                delete this.location['zip'];
                this.location['address'] = address;
                this.latLonAdvanceNextStep();
            }

            function showMessageIfFormNotCompleted(e) {
                if (this.currentStep.name != 'agentIntroduction') {
                    e.preventDefault();
                    e.returnValue = '';
                }
            }

            //Prompts the user they are leaving form
            //TODO this should be disabled when form completed
            window.addEventListener("beforeunload", function (e) {
                showMessageIfFormNotCompleted(e);
            }, false);

            window.addEventListener("keyup", function (event) {
                app.enterKey(event);
            })
        }
    }

</script>

<style>
@import url('https://fonts.googleapis.com/css?family=Montserrat:300,500,700|Lato:300,400,700&display=swap');

body {
    background-color: #fafeff;
}

#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    font-size: 16px;
}

.main-content {
    display: flex;
    flex-direction:column;
    gap: 2rem;
}

.bold {
    font-weight: bold;
}

.fw-400 {
    font-weight: 400 !important;
}

.mb-1 {
    margin-bottom: 1em;
}

.center-80 {
    width: 80%;
    margin: 0px auto;
}

.nav-controls {
    margin-bottom: 1em;
    margin-top: 3em;
}

.next-button-text {
    font-weight: bold;
}

.step-progress-bar {
    margin-bottom: 30px;
    margin-top: 1em;
}

.questions h4 {
    margin-bottom: 1em;
    margin-top: 1em;
    font-weight: bold;
}

.contain {
    width: 90%!important;
    max-width: 600px;
}

.btn-outline-primary.disabled, .btn-outline-primary:disabled {
    color: #bbbbbb !important;
    border-color: #bbbbbb !important;
    background-color: #f3f3f3 !important;
}

.btn-outline-secondary:not(:disabled):not(.disabled):active, .btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .btn-outline-secondary.dropdown-toggle,
.btn-outline-secondary:hover {
    color: #fff !important;
    background-color: #0087ff !important;
    border-color: #0072d8 !important;
}

.nav-footer {
    display:flex;
    flex-direction:column;
    height: 100vh;
    justify-content: space-between;
}

.nav-footer .logo {
    width: 75%;
    padding-bottom: 2rem;
    padding-top: 2rem;
}

@media only screen and (max-width: 480px) {
    #app {
        font-size: 12px;
    }

    .questions h4 {
        font-size: 1.2rem;
    }
}
</style>

